import styled from 'styled-components';

export const StickyCategoryGrid = styled.div`
  display: grid;
  grid-template-columns: ${(props) => props.gridTemplate};
  @media (min-width: 720px) {
    grid-template-columns: 100%;
  }
`;

export const MobileCategoriesSec = styled.section`
  display: none;

  @media (max-width: 720px) {
    display: block;
    position: sticky;
    z-index: 9;
    top: 56px;
    height: calc(100vh - 60px);
    overflow-y: auto;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.16);
    background-color: #f6f6f6;

    &::-webkit-scrollbar {
      width: 2px;
    }
  }
`;

export const ScrollableListSection = styled.nav`
  display: flex;
  justify-content: space-between;
  overflow-y: scroll;
  flex-direction: column;

  &::-webkit-scrollbar {
    display: none;
  }

  a {
    flex-basis: 28%;
    flex-shrink: 0;
    text-align: center;
    padding: 10px;

    span {
      position: unset !important;
    }

    .image {
      object-fit: contain;
      width: 100% !important;
      position: relative !important;
      height: 100% !important;
    }

    p {
      font-size: 10px;
      font-weight: 600;
      color: hsl(0deg, 0%, 0%, 80%);
      text-align: center;
      padding: 6px 2px;
    }
    transition:
      all 0.3s cubic-bezier(0.155, 1.105, 0.295, 1.12) 0s,
      box-shadow 0.3s ease 0s;

    &.lowOpacity {
      opacity: 0.4;
    }

    &.selectedBorder {
      position: relative;
      background-color: #fff;
      &::before {
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        width: 4px;
        height: 100%;
        background-color: #ef4e5e;
        border-radius: 0 25px 25px 0;
      }
    }
  }
`;
